export default __webpack_public_path__ + "static/media/about-hero-image.84040657.svg";